import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getProductMinimal } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.GET.MINIMAL,
  api: getProductMinimal,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/products/GetMinimalAction.js